import React, { FC, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { WhisperComponent } from './developers/page-components/WhisperComponent';

interface Props {
 value: string;
 additionalBoxClass?: string;
 additionalValueClass?: string;
}
export const OverflowTextComponent: FC<Props> = (props) => {
	const { value, additionalBoxClass, additionalValueClass } = props;

	const containerRef = useRef(null);
	const textRef = useRef(null);

	const [showTooltip, setShowTooltip] = useState(false);

	useEffect(() => {
		const textWidth = textRef.current.getBoundingClientRect().width;
		const areaWidth = containerRef.current.offsetWidth;

		if (Math.floor(textWidth) > areaWidth) {
			setShowTooltip(true);
		} else {
			setShowTooltip(false);
		}
	}, []);

	return (
		<div ref={containerRef} className={clsx(additionalBoxClass)}>
			{
				showTooltip
					? (
						<WhisperComponent
							whisperText={value}
							mainText={value}
							placement="autoVertical"
							trigger="hover"
							additionalClass={clsx('d-block fs-6 text-truncate', additionalValueClass)}
						/>
					) : (
						<span ref={textRef} className={clsx('text-truncate', additionalValueClass)}>{value}</span>
					)
			}

		</div>
	);

};